import { Bounce, ToastContainer } from "react-toastify";
import { router } from "./routes/index";
import { RouterProvider } from "react-router";
import store from "./store/index";
import { Provider } from "react-redux";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "./store";
import { setIsMobile } from "./store/navMobile";

function AppContent() {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    const checkScreenSize = () => {
      const isMobile = window.innerWidth < 991;
      dispatch(setIsMobile(isMobile));
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, [dispatch]);

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={true}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
      <RouterProvider router={router} />
    </>
  );
}

export default function App() {
  return (
    <Provider store={store}>
      <AppContent />
    </Provider>
  );
}
